import { getLocale } from "../runtime";

const sv_notifyerror = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Något gick fel. Försök igen senare.`
};

const notifyerror = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifyerror(inputs)
	return "notifyError";
};

export { notifyerror as "notifyError" };